import { apiRoutes } from "@/services/api/routes";
import formDataClient from "@/services/axios/formData-client";
const formDataConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export const getRFQDetails = async ({page,limit}:any={}) => {
  try {
    return await formDataClient.get(
      apiRoutes().buyer.manage.fetchRFQ,{params:{page,limit}}
    );
  } catch (exception) {
    throw exception;
  }
};

export const getRFQDetail = async () => {
  try {
    return await formDataClient.get(
      apiRoutes().buyer.manage.fetchRFQDetails
    );
  } catch (exception) {
    throw exception;
  }
};